/*
 * Woods Furniture - checkout offer labels on Boost product grids (Oct 2026).
 * Boost renders collection/search/recommendation cards in the browser, so the theme's
 * card label can't reach them. This adds a red label on the card image for any product
 * tagged "checkout-label:<text>", e.g. "checkout-label:Extra £150 off at checkout".
 * Remove the tag from a product to remove its label.
 */
(function () {
  var TAG_PREFIX = 'checkout-label:';
  var LABEL_CLASS = 'woods-checkout-label';
  var CSS =
    '.' + LABEL_CLASS + '{position:absolute;left:8px;bottom:8px;z-index:3;max-width:calc(100% - 16px);' +
    'padding:6px 10px;background:#c03d37;color:#fff;font-size:13px;font-weight:600;line-height:1.25;' +
    'border-radius:3px;text-align:center;pointer-events:none;}' +
    '@media (max-width:749px){.' + LABEL_CLASS + '{font-size:11px;padding:4px 7px;left:6px;bottom:6px;max-width:calc(100% - 12px);}}';

  function addStyle() {
    if (document.getElementById('woods-checkout-label-css')) return;
    var style = document.createElement('style');
    style.id = 'woods-checkout-label-css';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function getLabel(item) {
    var raw = item.getAttribute('data-product');
    if (!raw) return null;
    var tags = null;
    try {
      tags = JSON.parse(raw).tags;
    } catch (e) {
      var match = raw.match(/"tags"\s*:\s*(\[[^\]]*\])/);
      if (match) {
        try { tags = JSON.parse(match[1]); } catch (e2) { tags = null; }
      }
    }
    if (!tags || !tags.length) return null;
    for (var i = 0; i < tags.length; i++) {
      var tag = String(tags[i]);
      if (tag.toLowerCase().indexOf(TAG_PREFIX) === 0) {
        var text = tag.slice(TAG_PREFIX.length).trim();
        if (text) return text;
      }
    }
    return null;
  }

  function applyLabels() {
    var items = document.querySelectorAll('.boost-sd__product-item');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var text = getLabel(item);
      var existing = item.querySelector('.' + LABEL_CLASS);
      if (!text) {
        if (existing) existing.remove();
        continue;
      }
      if (existing) {
        if (existing.textContent !== text) existing.textContent = text;
        continue;
      }
      var wrapper = item.querySelector('.boost-sd__product-image-wrapper');
      if (!wrapper) continue;
      if (window.getComputedStyle(wrapper).position === 'static') wrapper.style.position = 'relative';
      var label = document.createElement('div');
      label.className = LABEL_CLASS;
      label.textContent = text;
      wrapper.appendChild(label);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      applyLabels();
    });
  }

  function init() {
    addStyle();
    applyLabels();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
